const scrollDown = document.getElementById("scroll-down");

if (document.body.classList.contains('home-page') && scrollDown) {

    scrollDown.addEventListener("click", () => {
        const nextSection = document.querySelector(".textimage-section-wrapper");
        if (nextSection) {
        nextSection.scrollIntoView({ behavior: "smooth" });
        }
    });

};


const menuToggle = document.querySelector('.tenc-menu-toggle');
const mainNavigation = document.querySelector('.tenc-main-navigation');

if (menuToggle && mainNavigation) {
    const closeMenu = () => {
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
        mainNavigation.classList.remove('is-open');
    };

    menuToggle.addEventListener('click', () => {
        const isOpen =
            menuToggle.getAttribute('aria-expanded') === 'true';

        menuToggle.setAttribute('aria-expanded', String(!isOpen));
        menuToggle.setAttribute(
            'aria-label',
            isOpen ? 'Open menu' : 'Close menu'
        );

        mainNavigation.classList.toggle('is-open', !isOpen);
    });

    mainNavigation.addEventListener('click', event => {
        if (event.target.closest('a')) {
            closeMenu();
        }
    });

    document.addEventListener('keydown', event => {
        if (
            event.key === 'Escape' &&
            menuToggle.getAttribute('aria-expanded') === 'true'
        ) {
            closeMenu();
            menuToggle.focus();
        }
    });
}